export default __webpack_public_path__ + "static/media/Angola.2d297206.png";